// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "125b0b3-dirty",
    "hash": "125b0b3",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "125b0b3-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
